const SETTINGS = {
  phoneNumber: '072-646-7733',
  reservation: 'https://clinics-app.com/clinic/676d063ff63b542ac7c8fa65/reservation'
}

export default SETTINGS
